import { Select } from "@chakra-ui/react";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { AppLanguage, SUPPORTED_LANGUAGES } from "i18n";

type LanguageSwitcherProps = {
  variant?: "light" | "dark";
};

const LanguageSwitcher = ({ variant = "light" }: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation("common");
  const currentLanguage = (i18n.resolvedLanguage || i18n.language || "en").split(
    "-"
  )[0] as AppLanguage;
  const isDark = variant === "dark";

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const nextLanguage = event.target.value as AppLanguage;
    if (SUPPORTED_LANGUAGES.includes(nextLanguage)) {
      void i18n.changeLanguage(nextLanguage);
    }
  };

  return (
    <Select
      aria-label={t("language")}
      value={SUPPORTED_LANGUAGES.includes(currentLanguage) ? currentLanguage : "en"}
      onChange={handleChange}
      size="sm"
      maxW="96px"
      pl="8px"
      bg={isDark ? "rgba(255,255,255,0.15)" : "#F5F7FB"}
      borderColor={isDark ? "rgba(255,255,255,0.35)" : "#D0DAFB"}
      color={isDark ? "inherit" : "#161A5C"}
      borderRadius="8px"
      fontSize="12px"
      fontWeight="500"
      _hover={{
        borderColor: isDark ? "rgba(255,255,255,0.55)" : "#A8B8F0",
      }}
      _focusVisible={{
        borderColor: isDark ? "rgba(255,255,255,0.8)" : "primary",
        boxShadow: "none",
      }}
    >
      <option value="en" style={{ color: "#161A5C" }}>
        {t("english")}
      </option>
      <option value="fr" style={{ color: "#161A5C" }}>
        {t("french")}
      </option>
    </Select>
  );
};

export default LanguageSwitcher;
